module.exports = __webpack_public_path__ + "static/img/next-page.7cf34be9.svg";